module.exports = __webpack_public_path__ + "img/logo-light.ad138d11.svg";